<template>
  <main>
    <div class="container-fluid pt-3">

      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">{{email}}</h5>
                <p class="mb-0 font-weight-bold text-sm">{{auth}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-lg-6 col-12  mb-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <p class="text-uppercase text-sm">유저정보</p>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">아이디</label>
                  <input class="form-control" type="text" v-model="email" readonly />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">권한</label>
                  <input class="form-control" type="text" :value="auth" readonly />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">지갑주소</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="address" readonly />
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">보유개수[TRON]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">

                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">보유개수[USDT]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="usdt_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">

                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">보유개수[MCS]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <button type="button"  class="btn btn-lg mt-3 mb-0 ms-auto btn-danger"  data-bs-toggle="modal" data-bs-target="#password_edit">비밀번호 변경</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="modal" tabindex="-1" id="password_edit">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">비밀번호 변경</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">현재 비밀번호</label>
            <input type="password" class="form-control" v-model="old_password"/>
            <label for="example-text-input" class="form-control-label">변경할 비밀번호</label>
            <input type="password" class="form-control" v-model="password"/>
            <label for="example-text-input" class="form-control-label">변경할 비밀번호 확인</label>
            <input type="password" class="form-control" v-model="password_confirm"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="ChangePassword()">비밀번호 변경</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapMutations } from "vuex";
const CryptoJS = require("crypto-js");
export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      email : '',
      auth : '',
      address : '',
      usdt_balance : '',
      tron_balance : '',
      mcs_balance : '',
      add_memo : '',
      sub_balance :'',
      sub_memo : '',
      memo : '',
      admin_histroy_list : [],
      old_password : '',
      password:'',
      password_confirm :'',
      mobile :this.$store.state.mobile,
      show_mobile :this.$store.state.show_mobile,
    };
  },
  components: {},

  mounted() {
    // this.GetAdminHistroy();
    this.GetProfile();
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = false;
    this.$store.state.isAbsolute = false;
    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }
  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
    ChangePassword(){
      const old_password = this.old_password;
      const password = this.password;
      const passowrd_confirm = this.password_confirm;

      if(old_password ==''){
        this.$alert.alert("현재 비밀번호를 입력해주세요.");
        return false;
      }

      if(password ==''){
        this.$alert.alert("변경할 비밀번호를 입력해주세요.");
        return false;
      }

      if(password != passowrd_confirm){
        this.$alert.alert("비밀번호를 확인해주세요.");
        return false;
      }

      const body = {old_password,password};
      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
      this.axios.post('/admin/profile/ChangePassword', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.$alert.alert("비밀번호를 변경하였습니다.").then(
                ()=>{
                  this.$store.dispatch('SETLOGOUT').then(
                    ()=>{
                      window.location.href="/login";
                    }
                  )
                }
              );
            }else if(res.data.code=='100'){
              this.$alert.alert("기존 비밀번호를 확인해주세요.");
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    GetType(type){

      if(type =='M'){
        return '차감'
      }else if(type =='P'){
        return '추가'
      }

    },
    GetProfile(){
      this.axios.post('/admin/profile/GetProfile', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){

              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.email = body.email;
              this.auth = body.auth;
              this.address = body.wallet.address;
              this.tron_balance = body.wallet.balance;
              this.usdt_balance = body.usdt_balance;
              this.mcs_balance = body.mcs_balance;

            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckBalance(){
      this.axios.post('/admin/profile/GetWalletBalance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.tron_balance = body.wallet.balance;
              this.usdt_balance = body.usdt_balance;
              this.mcs_balance = body.mcs_balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
  }
};
</script>
